import React from "react";

const Button = ({ variant = "primary", children, onClick }) => {
  const className = {
    primary:
      "rounded-[24px] bg-[#0033FF] text-[#EDF1FF] text-[14px] font-[700] py-[8px] px-[28px] cursor-pointer transition-all duration-500 hover:bg-[#001F6D]",
    secondary:
      "rounded-[24px] bg-[#EDF1FF] text-[#0033FF] text-[14px] font-[700] py-[8px] px-[28px] cursor-pointer transition-all duration-500 hover:bg-[#0033FF] hover:text-[#EDF1FF]",
  };
  return (
    <button className={className[variant]} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
